const settingConstants = {
    Phone: "general.info.general.phone",
    Email: "general.info.general.footer_email",
    Footer_Address: "general.info.general.footer_address",
    Custom_Css: "general.content.custom_scripts.custom_css",
    Custom_Javascript: "general.content.custom_scripts.custom_javascript",
    Custom_Analytics_GTAG: "general.content.custom_scripts.custom_google_analytic",
    Gdpr_Content: "general.gdpr.general.content",
    Gdpr_Title: "general.gdpr.general.title",
    Gdpr_Active: "general.gdpr.general.active",
    Out_Of_Stock: "catalog.products.homepage.out_of_stock_items",
    Guest_Checkout: "catalog.products.guest-checkout.allow-guest-checkout",
    Backorders: "catalog.inventory.stock_options.backorders",
    Blog_Active: "theme.blog.active",
    Contact_Us_Active: "theme.contact_us.active",
    Subscribe_Active: "theme.subscription.active",
    Tracking_Active: "sales.tracking.tracking.active",
    Linkedin_Active: "customer.settings.social_login.enable_linkedin",
    Facebook_Active: "customer.settings.social_login.enable_facebook",
    Twitter_Active: "customer.settings.social_login.enable_twitter",
    Github_Active: "customer.settings.social_login.enable_github",
    Google_Active: "customer.settings.social_login.enable_google",
    Cache_Version: "general.cash_control.version",
    Footer_Content: "general.content.footer.footer_content",
    Footer_Powered: "general.content.footer.footer_powered",
    Infinite_Scroll: "catalog.categories.infinite_scroll.infinite_scroll",
    Recaptcha_active: "general.recaptcha.general.active",
    Recaptcha_key: "general.recaptcha.general.site_key",
    Blog_meta_title: "blog.meta.options.meta_title",
    Blog_meta_description: "blog.meta.options.meta_description",
    Blog_meta_keywords: "blog.meta.options.meta_keywords",
    Suspend_Status: "general.suspend.status",
    Age_Verify_Status: "general.age_widget.general.active",
    Age_Verify_Cat_Slugs: "general.age_widget.general.slugs",
    Age_Verify_Title: "general.age_widget.general.text",
    Age_Verify_Yes: "general.age_widget.general.button_yes",
    Age_Verify_No: "general.age_widget.general.button_no",
    Age_Verify_Image: "general.age_widget.general.image",
    Facebook_Pixel_id: "general.content.facebook_pixel.identifier",
    PageTrack_Status: "general.content.facebook_pixel.track_page",
    AddToCart_Status: "general.content.facebook_pixel.add_to_cart",
    Checkout_status: "general.content.facebook_pixel.checkout",
    PlaceOrder_Status: "general.content.facebook_pixel.place_order",
    Theme_account_active: "theme.account.active",
    Theme_wishlist_active: "theme.wishlist.active",
    Theme_cart_active: "theme.cart.active",
    Theme_search_active: "theme.search.active",
    Theme_categories_active: "theme.categories.active",
    Delivery_Time_Status: "sales.deliverySlots.general.status",
    Min_Day_Required: "sales.deliverySlots.general.minimum_day_required",
    Delivery_Interval: "sales.deliverySlots.general.interval",
    Delivery_Monday_Active: "sales.deliverySlots.monday.active",
    Delivery_Monday_Start_Time: "sales.deliverySlots.monday.startTime",
    Delivery_Monday_End_Time: "sales.deliverySlots.monday.endTime",
    Delivery_Tuesday_Active: "sales.deliverySlots.tuesday.active",
    Delivery_Tuesday_Start_Time: "sales.deliverySlots.tuesday.startTime",
    Delivery_Tuesday_End_Time: "sales.deliverySlots.tuesday.endTime",
    Delivery_Wednesday_Active: "sales.deliverySlots.wednesday.active",
    Delivery_Wednesday_Start_Time: "sales.deliverySlots.wednesday.startTime",
    Delivery_Wednesday_End_Time: "sales.deliverySlots.wednesday.endTime",
    Delivery_Thursday_Active: "sales.deliverySlots.thursday.active",
    Delivery_Thursday_Start_Time: "sales.deliverySlots.thursday.startTime",
    Delivery_Thursday_End_Time: "sales.deliverySlots.thursday.endTime",
    Delivery_Friday_Active: "sales.deliverySlots.friday.active",
    Delivery_Friday_Start_Time: "sales.deliverySlots.friday.startTime",
    Delivery_Friday_End_Time: "sales.deliverySlots.friday.endTime",
    Delivery_Saturday_Active: "sales.deliverySlots.saturday.active",
    Delivery_Saturday_Start_Time: "sales.deliverySlots.saturday.startTime",
    Delivery_Saturday_End_Time: "sales.deliverySlots.saturday.endTime",
    Delivery_Sunday_Active: "sales.deliverySlots.sunday.active",
    Delivery_Sunday_Start_Time: "sales.deliverySlots.sunday.startTime",
    Delivery_Sunday_End_Time: "sales.deliverySlots.sunday.endTime",
    Shipping_City_Active: "sales.carriers.citybased.active",
    Request_Form_ID: "catalog.products.request_by_form.form",
    Request_Form_Btn: "catalog.products.request_by_form.text",
    Request_Form_Title: "catalog.products.request_by_form.title",
    Request_Form_Active: "catalog.products.request_by_form.active",
    Theme_Search_Product: "theme.search_by_products.active",
    Theme_Search_Page: "theme.search_by_pages.active",
    Theme_Search_Post: "theme.search_by_posts.active",
    Theme_Postal_Code_Active: "theme.postal_code.active",
    Theme_Apartment_Suite_Active: "theme.apartment_suite.active",
    Theme_Same_Shipping_Active: "theme.same_as_shipping.active",
    Catalog_Infinite_Scroll: "catalog.categories.infinite_scroll.infinite_scroll",
    Theme_Slug: "theme_slug",
    Google_Map_Api_Key: "general.recaptcha.google_maps.api_key",
    Google_Map_Enable_Pickup_Location: "general.recaptcha.google_maps.enable_pickup_location_map",
    Google_Map_Enable_Address_Search: "general.recaptcha.google_maps.enable_address_search_map",
}

module.exports = settingConstants